import styled from 'styled-components';
import AdminConfirmationModal from 'components/admin2/AdminConfirmationModal';

export const StyledAdminConfirmationModal = styled(AdminConfirmationModal)`
  max-width: 353px;
`;
